import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNurseWorkspace } from '../nurseWorkspaceContext';
import { NursePageHeader } from '../ui';
import NursePosteInfirmieSection from '../panels/NursePosteInfirmieSection';
import ClinicalButton from '../../doctor/ui/ClinicalButton';
import '../NurseDashboard.css';

export default function NurseAccueilPage() {
  const navigate = useNavigate();
  const {
    workSites,
    workSiteId,
    toast,
    consultations,
    loading,
    loadQueue,
    syncAfterPatientReceived,
    paths,
    copy,
    consultationEditPath
  } = useNurseWorkspace();

  const A = copy.ACCUEIL;

  const currentSite = useMemo(
    () => workSites.find((s) => String(s.id) === String(workSiteId)) || null,
    [workSites, workSiteId]
  );

  const handleIntakeSuccess = (consultation) => {
    syncAfterPatientReceived(consultation);
  };

  return (
    <div className="nr-accueil recv-dash-pro--main">
      <NursePageHeader
        badge={A.BADGE}
        title={A.PAGE_TITLE}
        description={A.PAGE_SUBTITLE}
        actions={
          <ClinicalButton variant="secondary" icon="refresh" onClick={loadQueue} disabled={!workSiteId || loading}>
            {A.REFRESH}
          </ClinicalButton>
        }
      />

      <NursePosteInfirmieSection
        id="nurse-accueil-poste"
        ariaLabel={A.SECTION_ARIA}
        badge={A.SECTION_BADGE}
        title={A.SECTION_TITLE}
        description={
          currentSite?.name ? (
            <>
              Site <strong>{currentSite.name}</strong> — {A.SECTION_DESC_SITE}
            </>
          ) : (
            A.SECTION_DESC
          )
        }
        workSiteId={workSiteId}
        siteName={currentSite?.name || ''}
        toast={toast}
        consultations={consultations}
        loading={loading}
        onRefresh={loadQueue}
        onIntakeSuccess={handleIntakeSuccess}
        onOpenConsultation={(id) => navigate(consultationEditPath(id))}
        onSeeAllFile={() => navigate(paths.FILE)}
        todayOnly
      />
    </div>
  );
}
